module.exports = __webpack_public_path__ + "img/Black-Box-img-ja.71241357.png";